import { styled, Box, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { LIGHT_TEXT, DARK_TEXT } = COLORS;

export const MainCont = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'scroll',
}));

export const NoData = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.type === 'dark' ? LIGHT_TEXT : DARK_TEXT,
  textAlign: 'center',
  marginTop: 30,
}));
